export default "__VITE_ASSET__4ca29add__"